module.exports = {
  "deviceOpsRecord": {
    'page': '运行记录',
    'list': '运行记录',
    'tenantName': '租户名称',
    'deviceName': '设备名称',
    'deviceInfo': '设备信息',
    'activeSeconds': '当前运行时长（秒）',
    'onlineTime': '上线时间',
    'offlineTime': '下线时间',
    'search_input1': '租户名称',
    'search_input2': '设备名称',
    'search_input3': '设备信息'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/device/en.js